<template>
  <div v-for="(idx, item) in new Array(20)" :key="'row-' + (idx + 1)" class="data-row contents">
    <div v-if="choosable" class="data-cell py-5" />
    <div v-if="pinnable" class="data-cell py-5" />
    <div
      v-for="column in columns"
      :key="idx + '_' + column.key"
      class="data-cell py-5"
      :class="column.class"
    >
      <slot :name="column.key" v-bind="{ item, value: '', column }" />
    </div>
    <div v-if="actions" class="data-cell py-5" />
  </div>
</template>

<script lang="ts" setup>
import type { Column } from './Table.vue';

interface Props {
  columns: Column[];
  actions?: boolean;
  choosable?: boolean;
  pinnable?: boolean;
}
defineProps<Props>();
</script>

<style lang="scss" scoped></style>
